import React from 'react';
import { Button, LoadMoreButtonWrapper } from 'mm-ui-components';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { fetchNextPosts } from '../../store/template/feedPage/feedPage.actions';
import { getSectionNextByKey, getSectionTextByKey } from '../../store/template/feedPage/feedpage.selectors';
import { SectionNames } from '../../store/template/feedPage/feedPage.reducer';
import { AppActions, FeedPageAppState } from '../../store/initialStateRegistration';

interface LoadMoreButtonProps {
    sectionKey: SectionNames
}

interface LoadMoreButtonConnectedProps {
    shouldDisplay: boolean
    onClick: () => void
    text: string | null
}

export const mapStateToProps = (state:FeedPageAppState, { sectionKey }:LoadMoreButtonProps) => {
  return {
    shouldDisplay: !!getSectionNextByKey(sectionKey)(state),
    text: getSectionTextByKey(sectionKey)(state),
  };
};

export const mapDispatchToProps = (dispatch:ThunkDispatch<FeedPageAppState, undefined, AppActions>, { sectionKey }:LoadMoreButtonProps) => {
  return {
    onClick: () => dispatch(fetchNextPosts(sectionKey)),
  };
};

const LoadMoreConnected: React.FunctionComponent<LoadMoreButtonConnectedProps> = ({ onClick, shouldDisplay, text }) => (
    shouldDisplay ? (
      <LoadMoreButtonWrapper>
        <Button onClick={onClick} label={text} />
      </LoadMoreButtonWrapper>
    ) : null);

export const LoadMoreButton = connect(mapStateToProps, mapDispatchToProps)(LoadMoreConnected);
